import { render, staticRenderFns } from "./wajaran.vue?vue&type=template&id=02c31d62"
import script from "./wajaran.vue?vue&type=script&lang=js"
export * from "./wajaran.vue?vue&type=script&lang=js"
import style0 from "./wajaran.vue?vue&type=style&index=0&id=02c31d62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports